export enum OPERATING_SYSTEM {
  MAC = "mac",
  WINDOWS = "windows",
  LINUX = "linux",
}

/**
 * Retrieve the OS of the NH's browser is currently running on.
 */
export const getOS = (): string => {
  const platformString = navigator.userAgent;
  if (platformString.includes("Mac")) return OPERATING_SYSTEM.MAC;
  else if (platformString.includes("Win")) return OPERATING_SYSTEM.WINDOWS;
  else if (platformString.includes("Linux")) return OPERATING_SYSTEM.LINUX;
  return platformString;
};

/**
 * Return true if the D1W is rendered within an Electron App. Otherwise, returns false.
 */
export const isRunningOnElectron = (): boolean => {
  return window.navigator.userAgent.toLowerCase().includes("electron");
};
